// jshint esversion: 8
import idxById from '@/utils/idxById';

export default {
  SET_DATA: (state, payload) => state.data = payload,
  CLEAR_DATA: state => state.data = [],
  PUSH_DATA: (state, payload) => state.data.push(payload),
  UPDATE_BY_ID: (state, payload) => state.data.splice(idxById(state.data, payload.id), 1, payload)
};
